// ═══════════════════════════════════════════════════
// SOLOTO — Configuration front (point unique)
// ═══════════════════════════════════════════════════
// Le réseau est choisi AUTOMATIQUEMENT par l'URL où tourne la page :
//   • hostname listé dans PROD_HOSTS → mainnet-beta + proxy Helius (clé masquée serveur) ;
//   • partout ailleurs (localhost, IP, preview, staging) → devnet + RPC public.
// Défaut SÛR = devnet (faux argent). Aucun basculement manuel, aucun rebuild dédié :
// tu codes → localhost = devnet ; tu déploies sur le domaine de prod = mainnet.
// Pour ajouter un domaine de prod : l'inscrire dans PROD_HOSTS, nulle part ailleurs.

import idl from "../target/idl/soloto.json";
import { PublicKey } from "@solana/web3.js";

// Domaines de PRODUCTION (argent réel). Tout hostname absent de cette liste ⇒ devnet.
const PROD_HOSTS = ["soloto777.com", "www.soloto777.com"];

const HOST =
  (typeof window !== "undefined" && window.location && window.location.hostname) || "";
export const IS_MAINNET = PROD_HOSTS.includes(HOST);

export const NETWORK: string = IS_MAINNET ? "mainnet-beta" : "devnet";

// mainnet → proxy nginx /api/rpc du VPS : RPC dédié Helius, clé masquée côté serveur,
//           appelé same-origin depuis soloto777.com (aucun CORS).
// devnet  → RPC public Solana : rien à cacher, CORS ouvert, joignable depuis localhost.
export const RPC_URL = IS_MAINNET
  ? "https://soloto777.com/api/rpc"
  : "https://api.devnet.solana.com";

export const COMMITMENT = "confirmed" as const;

// Program IDs DISTINCTS selon le réseau (déploiements séparés — ce ne sont PAS les
// mêmes keypairs de programme) :
//   • mainnet → declare_id! de lib.rs, figé dans l'IDL généré ;
//   • devnet  → déploiement devnet historique, que suit aussi le bot (.env PROGRAM_ID).
// Si l'un des deux est redéployé à une nouvelle adresse, mettre à jour ICI.
const DEVNET_PROGRAM_ID = "4srtBgivRrsDtc8cLMTQnDpECEzDFVmNTomrkJMmSiw8";
export const PROGRAM_ID = new PublicKey(
  IS_MAINNET ? (idl as { address: string }).address : DEVNET_PROGRAM_ID,
);

// Compte Pyth pull oracle SOL/USD (PriceUpdateV2, même adresse devnet et mainnet)
export const PYTH_SOL_USD = new PublicKey(
  "7UVimffxr9ow1uXYxsr4LHAcV58mLzhmwaeKvJ1pjLiE",
);
